/* ============================================================
   AMÉ · tema Shopify
   Un solo archivo, sin dependencias. Reproduce el comportamiento de la web (ame-web-v2):
   entrada de tiras + logo que viaja, diapositivas arrastrables con parallax, columnas que se cruzan,
   camiseta que se voltea, manifiesto que se enciende, carrito lateral y ficha con tallas.
   La configuración llega en window.AME desde layout/theme.liquid.
   ============================================================ */
(() => {
  "use strict";

  const A = window.AME || {};
  const T = A.textos || {};
  const html = document.documentElement;
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const EXPO = "cubic-bezier(0.16, 1, 0.3, 1)";
  const STRONG = "cubic-bezier(0.77, 0, 0.175, 1)";

  /* ── Utilidades ─────────────────────────────────────────── */
  const pesos = new Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 });
  const precio = (centavos) => "$ " + pesos.format(Math.round(centavos / 100));
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  const tx = (plantilla, datos) => String(plantilla || "").replace(/\[(\w+)\]/g, (todo, k) => (datos && k in datos ? datos[k] : k === "marca" ? A.marca : todo));
  const normal = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").trim();
  const ORDEN_TALLAS = String(A.ordenTallas || "").split(",").map((x) => normal(x)).filter(Boolean);
  const lugarTalla = (t) => { const i = ORDEN_TALLAS.indexOf(normal(t)); return i < 0 ? 999 : i; };

  /* El scroll se bloquea mientras haya algo encima (carrito, menú, modal). */
  let candados = 0;
  const bloquear = () => { if (++candados === 1) html.style.overflow = "hidden"; };
  const soltar = () => { if (candados > 0 && --candados === 0) html.style.overflow = ""; };

  /* ── Reveal: [data-reveal] se muestra al entrar en pantalla; a los 1500 ms todo se muestra igual ── */
  function Reveal() {
    const mostrar = (el) => el.setAttribute("data-shown", "");
    const todos = () => $$("[data-reveal]:not([data-shown])");
    if (!("IntersectionObserver" in window)) { todos().forEach(mostrar); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { mostrar(e.target); io.unobserve(e.target); } }), { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    todos().forEach((el) => io.observe(el));
    setTimeout(() => todos().forEach(mostrar), 1500);
    new MutationObserver(() => todos().forEach((el) => io.observe(el))).observe(document.body, { childList: true, subtree: true });
  }

  /* ── Entrada: tiras que se levantan y el logo que viaja a la cabecera ── */
  function Entrada() {
    const el = $("[data-entrada]");
    if (!el) return;
    if (html.classList.contains("sin-entrada") || reduce || !el.animate) { html.classList.add("sin-entrada"); el.remove(); return; }
    try { sessionStorage.setItem("ame-intro", "1"); } catch (e) { /* sin almacenamiento: se repite la próxima vez */ }
    html.dataset.intro = "playing";
    const tiras = $$("[data-tiras] > div", el);
    const logo = $("[data-logo-viajero]", el);
    const terminar = () => { delete html.dataset.intro; html.classList.add("sin-entrada"); el.remove(); };
    const correr = () => {
      tiras.forEach((t, i) => t.animate([{ transform: "translateY(0)" }, { transform: "translateY(-101%)" }], { duration: 900, delay: 650 + i * 70, easing: STRONG, fill: "forwards" }));
      logo.animate([{ opacity: 0, transform: "translate(-50%, -50%) scale(0.94)" }, { opacity: 1, transform: "translate(-50%, -50%) scale(1)" }], { duration: 600, easing: EXPO, fill: "forwards" });
      const desde = logo.getBoundingClientRect();
      setTimeout(() => {
        const destino = $("#header-logo");
        if (!destino) { terminar(); return; }
        const a = destino.getBoundingClientRect();
        const s = a.width / desde.width;
        const dx = a.left + a.width / 2 - (desde.left + desde.width / 2);
        const dy = a.top + a.height / 2 - (desde.top + desde.height / 2);
        const colorFinal = getComputedStyle(destino).color;
        const anim = logo.animate(
          [{ transform: "translate(-50%, -50%) scale(1)", color: getComputedStyle(logo).color }, { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(${s})`, color: colorFinal }],
          { duration: 1000, easing: STRONG, fill: "forwards" },
        );
        anim.onfinish = terminar;
      }, 1350);
    };
    /* Si la pestaña se abrió en segundo plano, la entrada espera a que la miren. */
    if (document.hidden) document.addEventListener("visibilitychange", () => !document.hidden && correr(), { once: true });
    else correr();
    el.addEventListener("pointerdown", terminar);
  }

  /* ── Cabecera: transparente sobre las diapositivas; menú del celular ── */
  function Cabecera() {
    const cab = $("[data-cabecera]");
    if (!cab || cab.__listo) return;
    cab.__listo = true;
    const centinela = $("#hero-sentinel");
    if (centinela) new IntersectionObserver(([e]) => cab.toggleAttribute("data-transparente", e.isIntersecting), { rootMargin: "-72px 0px 0px 0px" }).observe(centinela);
    else cab.removeAttribute("data-transparente");

    const menu = $("[data-menu-movil]");
    if (!menu) return;
    menu.inert = true;
    let abierto = false;
    let previo = null;
    const tecla = (e) => e.key === "Escape" && cerrar();
    function abrir() {
      if (abierto) return;
      abierto = true;
      previo = document.activeElement;
      menu.setAttribute("data-abierto", "");
      menu.inert = false;
      $$("[data-wa-flotante]").forEach((b) => b.setAttribute("data-oculto", ""));
      $$("[data-abre-menu]", cab).forEach((b) => b.setAttribute("aria-expanded", "true"));
      bloquear();
      window.addEventListener("keydown", tecla);
      ($("a, button", menu) || menu).focus({ preventScroll: true });
    }
    function cerrar() {
      if (!abierto) return;
      abierto = false;
      menu.removeAttribute("data-abierto");
      menu.inert = true;
      $$("[data-wa-flotante]").forEach((b) => b.removeAttribute("data-oculto"));
      $$("[data-abre-menu]", cab).forEach((b) => b.setAttribute("aria-expanded", "false"));
      soltar();
      window.removeEventListener("keydown", tecla);
      if (previo && previo.focus) previo.focus({ preventScroll: true });
    }
    $$("[data-abre-menu]", cab).forEach((b) => b.addEventListener("click", abrir));
    $$("[data-cierra-menu]", menu).forEach((b) => b.addEventListener("click", cerrar));
    matchMedia("(min-width: 1024px)").addEventListener("change", (e) => e.matches && cerrar());
  }

  /* ── Carrito: panel lateral con el carrito de Shopify ───── */
  const Carrito = (() => {
    const raiz = $("[data-carrito]");
    const nada = { abrir() {}, cerrar() {}, agregar: async () => "error" };
    if (!raiz) return nada;
    const panel = $("[data-carrito-panel]", raiz);
    const enCarrito = document.body.classList.contains("plantilla-cart");
    let abierto = false;
    let previo = null;
    const tecla = (e) => e.key === "Escape" && cerrar();
    function abrir() {
      if (abierto || enCarrito) return;
      abierto = true;
      previo = document.activeElement;
      raiz.setAttribute("data-abierto", "");
      raiz.inert = false;
      panel.focus({ preventScroll: true });
      window.addEventListener("keydown", tecla);
      bloquear();
      $$("[data-wa-flotante]").forEach((b) => b.setAttribute("data-oculto", ""));
    }
    function cerrar() {
      if (!abierto) return;
      abierto = false;
      raiz.removeAttribute("data-abierto");
      raiz.inert = true;
      window.removeEventListener("keydown", tecla);
      soltar();
      $$("[data-wa-flotante]").forEach((b) => b.removeAttribute("data-oculto"));
      if (previo && previo.focus) previo.focus({ preventScroll: true });
    }
    function contar(n) {
      $$("[data-carrito-cuenta]").forEach((el) => { el.textContent = n; el.hidden = n === 0; });
      $$("[data-abre-carrito]").forEach((el) => el.setAttribute("aria-label", tx(el.dataset.etiqueta, { n })));
    }
    function pintar(seccion) {
      const nuevo = new DOMParser().parseFromString(seccion, "text/html").querySelector("[data-carrito-contenido]");
      const actual = $("[data-carrito-contenido]", raiz);
      if (!nuevo || !actual) return;
      actual.replaceWith(nuevo);
      contar(Number(nuevo.dataset.unidades) || 0);
    }
    async function refrescar() {
      try {
        const r = await fetch(`${A.rutas.carrito}?sections=carrito`, { headers: { Accept: "application/json" } });
        const j = await r.json();
        if (j && j.carrito) pintar(j.carrito);
      } catch (e) { /* sin red: queda como estaba */ }
    }
    async function pedir(url, cuerpo) {
      try {
        const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ ...cuerpo, sections: "carrito" }) });
        const j = await r.json().catch(() => ({}));
        return { ok: r.ok, estado: r.status, j };
      } catch (e) { return { ok: false, estado: 0, j: {} }; }
    }
    async function agregar(id, cantidad) {
      const { ok, j } = await pedir(A.rutas.agregar, { items: [{ id, quantity: cantidad || 1 }] });
      if (ok) { if (j.sections && j.sections.carrito) pintar(j.sections.carrito); else await refrescar(); return "ok"; }
      await refrescar();
      return "error";
    }
    async function cambiar(clave, cantidad) {
      const { ok, j } = await pedir(A.rutas.cambiar, { id: clave, quantity: cantidad });
      if (enCarrito) { location.reload(); return; }
      if (ok && j.sections && j.sections.carrito) { pintar(j.sections.carrito); return; }
      await refrescar();
      const error = $("[data-carrito-error]", raiz);
      if (error) { error.textContent = (j && (j.description || j.message)) || T.errorCarrito || ""; error.hidden = !error.textContent; }
    }
    document.addEventListener("click", (e) => {
      const abre = e.target.closest("[data-abre-carrito]");
      if (abre && !enCarrito) { e.preventDefault(); abrir(); return; }
      if (e.target.closest("[data-cierra-carrito], [data-carrito-velo]")) { cerrar(); return; }
      const boton = e.target.closest("[data-cambia]");
      if (boton) { boton.disabled = true; cambiar(boton.dataset.cambia, Number(boton.dataset.cantidad)); }
    });
    window.addEventListener("pageshow", (e) => e.persisted && refrescar());
    return { abrir, cerrar, agregar };
  })();

  /* ── Muelle: anima un valor con física de resorte (rigidez, amortiguación, masa) ── */
  function muelle(desde, hasta, { k = 110, c = 24, m = 0.9 } = {}, alPintar, alTerminar) {
    let x = desde, v = 0, antes = performance.now(), id;
    const paso = (ahora) => {
      const dt = Math.min(0.034, (ahora - antes) / 1000);
      antes = ahora;
      v += ((k * (hasta - x) - c * v) / m) * dt;
      x += v * dt;
      if (Math.abs(hasta - x) < 0.5 && Math.abs(v) < 6) { x = hasta; alPintar(x); if (alTerminar) alTerminar(); return; }
      alPintar(x);
      id = requestAnimationFrame(paso);
    };
    id = requestAnimationFrame(paso);
    return () => cancelAnimationFrame(id);
  }

  /* ── Diapositivas: arrastre, parallax, contador, flechas, teclado y avance automático ── */
  function Diapositivas(sec) {
    if (sec.__listo) return;
    sec.__listo = true;
    const pista = $("[data-pista-diapositivas]", sec);
    const slides = $$("[data-diapositiva]", sec);
    const n = slides.length;
    if (!pista || n === 0) return;
    const fotos = slides.map((s) => $("[data-parallax]", s));
    const textos = slides.map((s) => $("[data-texto-diapositiva]", s));
    const contador = $("[data-contador]", sec);
    const tabs = $$("[data-ir]", sec);
    const intervalo = Number(sec.dataset.intervalo) || 6000;
    let w = sec.clientWidth;
    let i = 0;
    let x = 0;
    let cancelar = null;
    let arrastrando = false;
    let encima = false;

    const pintar = (valor) => {
      x = valor;
      pista.style.transform = `translate3d(${x}px, 0, 0)`;
      fotos.forEach((f, k) => f && (f.style.transform = `translate3d(${(x + k * w) * -0.25}px, 0, 0)`));
    };
    const activar = (k) => {
      i = ((k % n) + n) % n;
      slides.forEach((s, j) => s.setAttribute("aria-hidden", String(j !== i)));
      textos.forEach((t, j) => { if (!t) return; t.classList.toggle("opacity-0", j !== i); t.classList.toggle("translate-y-4", j !== i); const cta = $("[data-cta]", t); if (cta) cta.tabIndex = j === i ? 0 : -1; });
      tabs.forEach((t, j) => t.setAttribute("aria-selected", String(j === i)));
      if (contador) contador.textContent = String(i + 1).padStart(2, "0");
    };
    const ir = (k, inmediato) => {
      activar(k);
      if (cancelar) cancelar();
      if (inmediato || reduce) { pintar(-i * w); return; }
      cancelar = muelle(x, -i * w, {}, pintar);
    };
    new ResizeObserver(() => { w = sec.clientWidth; ir(i, true); }).observe(sec);
    activar(0);
    pintar(0);

    /* Arrastre con el puntero (mouse y dedo) */
    if (!reduce && n > 1) {
      let x0 = 0, xi = 0, t0 = 0, movido = false, puntero = null;
      pista.addEventListener("pointerdown", (e) => {
        if (e.button !== 0 && e.pointerType === "mouse") return;
        puntero = e.pointerId; x0 = e.clientX; xi = x; t0 = performance.now(); movido = false; arrastrando = true;
        if (cancelar) cancelar();
      });
      pista.addEventListener("pointermove", (e) => {
        if (!arrastrando || e.pointerId !== puntero) return;
        const dx = e.clientX - x0;
        if (!movido && Math.abs(dx) > 6) { movido = true; pista.setPointerCapture(puntero); pista.setAttribute("data-arrastrando", ""); }
        if (!movido) return;
        const min = -(n - 1) * w, max = 0;
        let nx = xi + dx;
        if (nx > max) nx = max + (nx - max) * 0.12;
        if (nx < min) nx = min + (nx - min) * 0.12;
        pintar(nx);
      });
      const fin = (e) => {
        if (!arrastrando || e.pointerId !== puntero) return;
        arrastrando = false;
        pista.removeAttribute("data-arrastrando");
        if (pista.hasPointerCapture(puntero)) pista.releasePointerCapture(puntero);
        if (!movido) return;
        const dx = e.clientX - x0;
        const vx = (dx / Math.max(1, performance.now() - t0)) * 1000;
        if (dx < -w * 0.18 || vx < -500) ir(i + 1);
        else if (dx > w * 0.18 || vx > 500) ir(i - 1);
        else ir(i);
      };
      pista.addEventListener("pointerup", fin);
      pista.addEventListener("pointercancel", fin);
      /* Si hubo arrastre, el clic que lo cierra no debe abrir el enlace. */
      pista.addEventListener("click", (e) => { if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; } }, true);
    }

    $$("[data-paso]", sec).forEach((b) => b.addEventListener("click", () => ir(i + Number(b.dataset.paso))));
    tabs.forEach((t) => t.addEventListener("click", () => ir(Number(t.dataset.ir))));
    window.addEventListener("keydown", (e) => {
      if (e.target.closest("input, textarea, select, [role=dialog]")) return;
      if (e.key === "ArrowRight") ir(i + 1);
      if (e.key === "ArrowLeft") ir(i - 1);
    });
    sec.addEventListener("mouseenter", () => (encima = true));
    sec.addEventListener("mouseleave", () => (encima = false));
    if (!reduce && n > 1) setInterval(() => { if (!arrastrando && !encima && !document.hidden) ir(i + 1); }, intervalo);
  }

  /* ── Progreso de scroll de un elemento entre dos puntos del viewport ── */
  const progreso = (el, inicio, fin) => {
    /* inicio/fin: [posición del elemento (0 = top, 1 = bottom), posición del viewport (0 = top, 1 = bottom)] */
    const r = el.getBoundingClientRect();
    const H = window.innerHeight;
    const a = r.top + r.height * inicio[0] - H * inicio[1];
    const b = r.top + r.height * fin[0] - H * fin[1];
    return Math.min(1, Math.max(0, a / (a - b)));
  };
  const alScroll = (fn) => {
    let pedido = false;
    const tick = () => { pedido = false; fn(); };
    const marcar = () => { if (!pedido) { pedido = true; requestAnimationFrame(tick); } };
    window.addEventListener("scroll", marcar, { passive: true });
    window.addEventListener("resize", marcar);
    marcar();
  };

  /* ── Categorías: la columna izquierda sube y la derecha baja ── */
  function Cruce(sec) {
    if (sec.__listo || reduce) return;
    sec.__listo = true;
    const sube = $('[data-columna="sube"]', sec);
    const baja = $('[data-columna="baja"]', sec);
    alScroll(() => {
      const p = progreso(sec, [0, 1], [1, 0]);
      if (sube) sube.style.transform = `translate3d(0, ${6 - 28 * p}%, 0)`;
      if (baja) baja.style.transform = `translate3d(0, ${-22 + 28 * p}%, 0)`;
    });
  }

  /* ── Manifiesto: se enciende palabra a palabra ─────────── */
  function Manifiesto(sec) {
    if (sec.__listo) return;
    sec.__listo = true;
    const palabras = $$("[data-palabra]", sec);
    const n = palabras.length;
    if (reduce) { palabras.forEach((p) => (p.style.opacity = 1)); return; }
    alScroll(() => {
      const p = progreso(sec, [0, 0.85], [1, 0.55]);
      palabras.forEach((el, i) => {
        const a = i / n, b = Math.min(1, (i + 1.5) / n);
        const t = Math.min(1, Math.max(0, (p - a) / (b - a)));
        el.style.opacity = (0.18 + 0.82 * t).toFixed(3);
      });
    });
  }

  /* ── Buena Suerte: la camiseta se voltea ───────────────── */
  function Voltea(boton) {
    if (boton.__listo) return;
    boton.__listo = true;
    const camiseta = $("[data-camiseta]", boton);
    const texto = $("[data-voltea-texto]", boton);
    boton.addEventListener("click", () => {
      const espalda = !camiseta.hasAttribute("data-espalda");
      camiseta.toggleAttribute("data-espalda", espalda);
      boton.setAttribute("aria-pressed", String(espalda));
      boton.setAttribute("aria-label", espalda ? boton.dataset.etiquetaFrente : boton.dataset.etiquetaEspalda);
      if (texto) texto.textContent = espalda ? texto.dataset.textoFrente : texto.dataset.textoEspalda;
    });
  }

  /* ── Carril de las más vendidas: flechas ───────────────── */
  function Carril(ul) {
    if (ul.__listo) return;
    ul.__listo = true;
    const sec = ul.closest("section");
    $$("[data-paso]", sec).forEach((b) =>
      b.addEventListener("click", () => {
        const li = $("li", ul);
        const paso = li ? li.getBoundingClientRect().width + 24 : ul.clientWidth * 0.8;
        ul.scrollBy({ left: Number(b.dataset.paso) * paso * 2, behavior: "smooth" });
      }),
    );
  }

  /* ── Catálogo: orden por URL y foco del buscador ───────── */
  function Catalogo(raiz) {
    if (raiz.__listo) return;
    raiz.__listo = true;
    const orden = $("[data-orden]", raiz);
    if (orden)
      orden.addEventListener("change", () => {
        const u = new URL(location.href);
        u.searchParams.set("sort_by", orden.value);
        u.searchParams.delete("page");
        location.assign(u);
      });
    if (new URLSearchParams(location.search).get("buscar") === "1") {
      const campo = $("#buscar", raiz);
      if (campo) { campo.focus(); campo.scrollIntoView({ block: "center", behavior: reduce ? "auto" : "smooth" }); }
    }
    /* Shopify entrega máximo 50 prendas por página: las demás se traen aquí para ver todo el catálogo de corrido, como en la web. */
    const rejilla = $("[data-rejilla]", raiz);
    const paginas = $("[data-paginas]", raiz);
    /* Con Sale aparte, el conteo de Shopify incluye las prendas saltadas: se cuenta lo que de verdad hay. */
    const recontar = () => {
      if (!raiz.hasAttribute("data-recontar")) return;
      const n = rejilla ? $$(":scope > li", rejilla).length : 0;
      const cuenta = $("[data-cuenta]", raiz);
      if (cuenta) cuenta.textContent = tx(cuenta.dataset.plantilla, { n });
    };
    if (!rejilla || !raiz.dataset.siguiente) { recontar(); return; }
    if (paginas) paginas.hidden = true;
    (async () => {
      let siguiente = raiz.dataset.siguiente;
      let vueltas = 0;
      while (siguiente && vueltas++ < 20) {
        try {
          const u = new URL(siguiente, location.origin);
          if (raiz.dataset.seccion) u.searchParams.set("section_id", raiz.dataset.seccion);
          const r = await fetch(u);
          if (!r.ok) break;
          const doc = new DOMParser().parseFromString(await r.text(), "text/html");
          $$("[data-rejilla] > li", doc).forEach((li) => { li.style.transitionDelay = ""; rejilla.appendChild(document.importNode(li, true)); });
          const otra = doc.querySelector("[data-catalogo]");
          siguiente = otra ? otra.dataset.siguiente : "";
        } catch (e) { break; }
      }
      recontar();
    })();
  }

  /* ── Ventanas modales ───────────────────────────────────── */
  const Modal = (() => {
    let actual = null, previo = null;
    const tecla = (e) => e.key === "Escape" && cerrar();
    function abrir(nodo) {
      if (!nodo || actual) return;
      actual = nodo; previo = document.activeElement;
      nodo.hidden = false;
      const caja = $('[role="dialog"]', nodo);
      if (caja) caja.focus({ preventScroll: true });
      window.addEventListener("keydown", tecla);
      bloquear();
    }
    function cerrar() {
      if (!actual) return;
      actual.hidden = true; actual = null;
      window.removeEventListener("keydown", tecla);
      soltar();
      if (previo && previo.focus) previo.focus({ preventScroll: true });
    }
    document.addEventListener("click", (e) => {
      const abre = e.target.closest("[data-abre-modal]");
      if (abre) abrir($(`[data-modal="${abre.dataset.abreModal}"]`));
      else if (e.target.closest("[data-modal-cerrar]")) cerrar();
    });
    return { abrir, cerrar };
  })();

  /* ── Ficha de la prenda ─────────────────────────────────── */
  function Ficha(raiz) {
    if (raiz.__listo) return;
    raiz.__listo = true;
    let d;
    try { d = JSON.parse($("script[data-prenda]", raiz).textContent); } catch (e) { return; }
    const tallas = (d.unica ? [] : d.tallas.slice()).sort((a, b) => lugarTalla(a) - lugarTalla(b));
    const variante = (t) => d.v.find((v) => (d.unica ? true : normal(v.t) === normal(t)));
    const unica = d.unica || tallas.length === 1;
    let talla = unica ? (d.unica ? null : tallas[0]) : null;
    let necesita = false;

    const cajaTallas = $("[data-tallas]", raiz);
    const nombreTalla = $("[data-talla-nombre]", raiz);
    const aviso = $("[data-aviso]", raiz);
    const boton = $("[data-comprar]", raiz);
    const etiqueta = $("[data-comprar-etiqueta]", raiz);
    const textoBoton = $("[data-comprar-texto]", raiz);
    const precioAhora = $("[data-precio-ahora]", raiz);
    const precioAntes = $("[data-precio-antes]", raiz);
    const guia = $('[data-modal="guia"]', raiz);

    const actual = () => (d.unica ? d.v[0] : talla ? variante(talla) : null);
    function pintarTallas() {
      if (!cajaTallas) return;
      cajaTallas.innerHTML = tallas
        .map((t) => {
          const v = variante(t);
          const ok = v ? v.d : true;
          const on = t === talla;
          const clase = on ? "border-wine bg-wine text-blush" : necesita ? "border-wine text-wine" : "border-wine/30 text-wine hover:border-wine";
          return `<button type="button" role="radio" aria-checked="${on}"${ok ? "" : " disabled"} data-talla="${esc(t)}" class="relative h-12 min-w-12 border px-4 font-display text-[0.8rem] uppercase tracking-[0.1em] transition-[background-color,color,transform] duration-150 active:scale-[0.97] ${clase}${ok ? "" : " cursor-not-allowed text-rose-ink line-through opacity-50"}">${esc(t)}</button>`;
        })
        .join("");
      cajaTallas.classList.toggle("ame-nudge", necesita && !talla);
      if (nombreTalla) nombreTalla.textContent = talla ? `: ${talla}` : "";
    }
    function pintarEstado() {
      const v = actual();
      if (aviso) {
        aviso.classList.toggle("text-wine", necesita);
        aviso.removeAttribute("role");
        if (!unica && !talla) { aviso.textContent = necesita ? T.primeroTalla || "Primero elige tu talla." : T.elige || "Elige una talla para agregar al carrito."; if (necesita) aviso.setAttribute("role", "alert"); }
        else if (v && !v.d) aviso.textContent = T.agotadaTalla || "Esta talla está agotada. Escríbenos y te avisamos cuando vuelva.";
        else aviso.textContent = "";
      }
      const p = v ? v.p : d.p;
      if (precioAhora) precioAhora.textContent = precio(p);
      if (precioAntes) { const cp = v ? v.cp : 0; precioAntes.hidden = !(cp > p); if (cp > p) precioAntes.textContent = precio(cp); }
      if (boton && d.d) { boton.disabled = Boolean(v && !v.d); ponerEtiqueta(tx(T.agregar || "Agregar al carrito · [precio]", { precio: precio(p) })); }
    }
    function ponerEtiqueta(texto) {
      if (!etiqueta || etiqueta.textContent === texto) return;
      etiqueta.textContent = texto;
      if (textoBoton) { textoBoton.removeAttribute("data-cambio"); void textoBoton.offsetWidth; textoBoton.setAttribute("data-cambio", ""); }
    }
    const elegir = (t) => { talla = t; necesita = false; pintarTallas(); pintarEstado(); pintarGuia(); };

    if (cajaTallas) cajaTallas.addEventListener("click", (e) => { const b = e.target.closest("button[data-talla]"); if (b && !b.disabled) elegir(b.dataset.talla); });
    if (boton)
      boton.addEventListener("click", async () => {
        const v = actual();
        if (!v) { necesita = true; pintarTallas(); pintarEstado(); cajaTallas && cajaTallas.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" }); return; }
        if (!v.d) return;
        boton.disabled = true;
        const r = await Carrito.agregar(v.id, 1);
        boton.disabled = false;
        if (r === "ok") { ponerEtiqueta(T.agregada || "Agregada al carrito"); Carrito.abrir(); setTimeout(pintarEstado, 1600); }
        else if (aviso) aviso.textContent = T.error || "No se pudo agregar. Inténtalo de nuevo.";
      });

    /* Guía de tallas: resalta las tallas de esta prenda y la elegida; tocar una columna la elige */
    function pintarGuia() {
      if (!guia) return;
      const disponibles = new Set(tallas.map(normal));
      const enTabla = [];
      $$("[data-elige-talla]", guia).forEach((b) => {
        const t = b.dataset.eligeTalla;
        const hay = disponibles.has(normal(t));
        b.disabled = !hay;
        b.setAttribute("aria-pressed", String(hay && talla && normal(talla) === normal(t)));
        if (hay) enTabla.push(t);
      });
      $$("td[data-col-talla]", guia).forEach((td) => {
        const t = td.dataset.colTalla;
        const on = talla && normal(talla) === normal(t);
        td.classList.toggle("bg-wine/[0.07]", Boolean(on));
        td.classList.toggle("font-normal", Boolean(on));
        td.classList.toggle("text-wine/35", !disponibles.has(normal(t)));
        td.classList.toggle("text-wine", disponibles.has(normal(t)));
      });
      const nota = $("[data-guia-aviso]", guia);
      const total = $$("[data-elige-talla]", guia).length;
      if (nota) {
        const lista = enTabla.length === 1 ? `talla ${enTabla[0]}` : `tallas ${enTabla.slice(0, -1).join(", ")} y ${enTabla.at(-1)}`;
        nota.hidden = !(enTabla.length > 0 && enTabla.length < total);
        nota.textContent = tx(T.vieneEn || "Esta prenda viene en [tallas]. Toca una para elegirla.", { tallas: lista });
      }
    }
    if (guia) guia.addEventListener("click", (e) => { const b = e.target.closest("[data-elige-talla]"); if (b && !b.disabled) { elegir(tallas.find((t) => normal(t) === normal(b.dataset.eligeTalla))); Modal.cerrar(); } });

    /* Galería de escritorio: miniaturas → foto grande */
    const grande = $("[data-foto-grande]", raiz);
    const plantilla = $("template[data-fotos]", raiz);
    const minis = $$("[data-miniatura]", raiz);
    if (grande && plantilla) {
      const fotos = Array.from(plantilla.content.children);
      minis.forEach((b) =>
        b.addEventListener("click", () => {
          const k = Number(b.dataset.miniatura);
          minis.forEach((m) => m.toggleAttribute("aria-current", m === b) || m.setAttribute("aria-current", String(m === b)));
          minis.forEach((m) => m.setAttribute("aria-current", String(m === b)));
          if (!fotos[k]) return;
          grande.innerHTML = "";
          grande.appendChild(fotos[k].cloneNode(true));
        }),
      );
    }

    /* Otros colores: prendas con el mismo nombre */
    const colores = $("[data-colores]", raiz);
    const lista = $("[data-colores-lista]", raiz);
    if (colores && lista && d.n && A.rutas.buscar) {
      const q = `title:"${d.n.replace(/"/g, "")}"`;
      fetch(`${A.rutas.buscar}?section_id=colores&type=product&q=${encodeURIComponent(q)}`)
        .then((r) => (r.ok ? r.text() : ""))
        .then((h) => {
          const doc = new DOMParser().parseFromString(h, "text/html");
          const otros = $$("li[data-titulo-prenda]", doc).filter((li) => normal(li.dataset.tituloPrenda) === normal(d.n) && li.dataset.handle !== d.h);
          if (!otros.length) return;
          otros.forEach((li) => lista.appendChild(document.importNode(li, true)));
          colores.hidden = false;
        })
        .catch(() => undefined);
    }

    pintarTallas();
    pintarEstado();
    pintarGuia();
  }

  /* ── Te puede combinar: sugerencias de Shopify ─────────── */
  function Relacionados(raiz) {
    if (raiz.__listo || !raiz.dataset.url) return;
    raiz.__listo = true;
    fetch(raiz.dataset.url)
      .then((r) => (r.ok ? r.text() : ""))
      .then((h) => {
        const doc = new DOMParser().parseFromString(h, "text/html");
        const nuevo = doc.querySelector("[data-relacionados]");
        if (!nuevo) return;
        /* Fuera las otras versiones de color de la misma prenda; tope en la cantidad pedida */
        const titulo = normal(raiz.dataset.titulo);
        const max = Number(raiz.dataset.cantidad) || 6;
        const lis = $$("li[data-titulo-prenda]", nuevo);
        let vistos = 0;
        lis.forEach((li) => { if (normal(li.dataset.tituloPrenda) === titulo || vistos >= max) li.remove(); else vistos++; });
        if (!vistos) return;
        raiz.innerHTML = nuevo.innerHTML;
      })
      .catch(() => undefined);
  }

  /* ── Cuenta: confirmar al eliminar una dirección y país por defecto ── */
  function Direcciones(raiz) {
    if (raiz.__listo) return;
    raiz.__listo = true;
    $$("[data-confirmar]", raiz).forEach((b) => b.addEventListener("click", (e) => { if (!window.confirm(b.dataset.confirmar)) e.preventDefault(); }));
    $$("select[data-default]", raiz).forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });
  }

  /* ── Arranque ───────────────────────────────────────────── */
  function iniciar(raiz) {
    const r = raiz || document;
    $$("[data-diapositivas]", r).forEach(Diapositivas);
    $$("[data-cruce]", r).forEach(Cruce);
    $$("[data-manifiesto]", r).forEach(Manifiesto);
    $$("[data-voltea]", r).forEach(Voltea);
    $$("[data-carril]", r).forEach(Carril);
    $$("[data-catalogo]", r).forEach(Catalogo);
    $$("[data-ficha]", r).forEach(Ficha);
    $$("[data-relacionados]", r).forEach(Relacionados);
    $$("[data-direcciones]", r).forEach(Direcciones);
    Cabecera();
  }

  Entrada();
  iniciar(document);
  Reveal();

  /* Editor de temas: una sección que se vuelve a pintar arranca de nuevo. */
  document.addEventListener("shopify:section:load", (e) => iniciar(e.target));
})();
